const insurancefile = [{
  desc: '查询保单附件',
  options: {
    url: '/insurancefiles/queryfile',
    method: 'post',
    // 该接口成功时后端返回 resultCode=1 + message="成功"，属用户模块 Message.SUCCESS 的
    // code 约定(1)与新框架(0)=成功不一致；这里跳过全局错误弹框，由调用方自行处理。
    needCustomMessage: true
  }
}, {
  desc: '保存保单附件',
  options: {
    url: '/insurancefiles/addfile',
    method: 'post'
  }
}, {
  desc: '删除保单附件',
  options: {
    url: '/insurancefiles/deleteByIds',
    method: 'post'
  }
}]
export default insurancefile



// WEBPACK FOOTER //
// ./src/api/insurancefile.js